export default __webpack_public_path__ + "static/prospectus-9d41c867c7cfd191a518dcd5e2429a06.jpg";